/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiMediaTypeFromJSON, ApiMediaTypeToJSON, } from './ApiMediaType';
export function ApiGetPresignedURLPayloadFromJSON(json) {
    return ApiGetPresignedURLPayloadFromJSONTyped(json, false);
}
export function ApiGetPresignedURLPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'tmp': !exists(json, 'tmp') ? undefined : json['tmp'],
        'type': !exists(json, 'type') ? undefined : ApiMediaTypeFromJSON(json['type']),
    };
}
export function ApiGetPresignedURLPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'path': value.path,
        'tmp': value.tmp,
        'type': ApiMediaTypeToJSON(value.type),
    };
}
